import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Blog } from '../../interfaces/Blog/Blog';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Blog>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'Başlık',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'cover-image',
    name: 'Kapak Resmi',
    accessor: (row) => <ImageColumn url={row.coverImage} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type BlogsTableProps = {
  blogs: Blog[];
};

export const BlogsTable = (props: BlogsTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.blogs, limit, page),
    [props.blogs, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.blogs.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(blog) => navigate(`/blogs/blogs/${blog.slug}`)}
    />
  );
};
